import { render, staticRenderFns } from "./RemoveModal.vue?vue&type=template&id=d3e2d992&"
import script from "./RemoveModal.vue?vue&type=script&lang=js&"
export * from "./RemoveModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports